import { Dtos } from "@inrev/common";
import { decisioningFactorGroupsQueryKey } from "../decisioning.keys";
import { type FactorGroup } from "../types";
import { useCreateCatalogItem } from "./catalog";

export const useCreateDecisioningFactorGroup = () => {
	const mutation = useCreateCatalogItem<FactorGroup, Dtos.Decisioning.FactorGroup.Create.Request>({
		path: "/v2/admin/decisioning/factor-groups",
		queryKey: decisioningFactorGroupsQueryKey(),
		responseSchema: Dtos.Decisioning.FactorGroup.Get.Response.schema,
	});

	return {
		createFactorGroupAsync: mutation.mutateAsync,
		createFactorGroupLoading: mutation.isPending,
	};
};
